module.exports = __webpack_public_path__ + "assets/images/EUR002.png";


//////////////////
// WEBPACK FOOTER
// ./client/app/assets/images/EUR002.png
// module id = 1357
// module chunks = 1